import moment from 'moment-timezone';
import logger from '../../../utils/logger';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';
import { ChangeMaterialMidBatchParams } from './types';

export const logSubstitution = (
  batchStore: any,
  originalMaterial: Material,
  substituteMaterial: Material,
  originalBin: Device,
  substituteBin: Device,
  params: ChangeMaterialMidBatchParams,
  currentScaleWeight: number,
  deferredWeight: number,
  runningData: any,
  scaleData: any,
) => {
  const { originalMaterialId, substituteMaterialId, scaleId, reason, currentWeight = 0 } = params;
  const remainingTarget = scaleData.mft - currentWeight;

  batchStore.saveLog({
    level: 'info',
    message: `Material substituted: ${originalMaterial.code} -> ${substituteMaterial.code}, bin switched from #${originalBin?.id} to #${substituteBin.id}`,
    data: {
      originalMaterialId,
      substituteMaterialId,
      scaleId,
      originalBinId: originalBin?.id,
      newBinId: substituteBin.id,
      reason,
      currentWeight,
      deferredWeight,
      batchId: runningData.uid,
      timestamp: moment().tz(batchStore.timezone).format(),
      currentScaleWeight,
      remainingTarget,
    },
  });

  batchStore.showSuccess(`Material substituted: ${originalMaterial.code} → ${substituteMaterial.code}, using bin #${substituteBin.id}. Remaining target: ${remainingTarget.toFixed(2)}`);
};

export const resumeBatchWithSubstitute = (batchStore: any, scaleId: string, runningData: any, substituteMaterial: Material) => {
  batchStore.setTimeout(() => {
    if (batchStore.isActiveDrop(runningData)) {
      logger.log('Starting batch with substitute material:', substituteMaterial.code);
      batchStore.batchDataForScale(Number(scaleId), runningData);
    }
  }, 500);
};
